import React from "react";
import { useLocation } from "react-router-dom";
import Header from "./header";
import Footer from "./footer";
import Navigation from "./navigation";

import { logo, logo_black, logo_1024x1024 } from "../images";
import mp4 from './../images/imagefilm-web_TmhUh8B3.mp4';
import fallBackImg from "./../images/Content/Backhaus-Häussler-49.jpg"

import config from "../config/Main.json";

interface LayoutProps {
  children: React.ReactNode;
}

const Layout: React.FunctionComponent<LayoutProps> = ({ children }) => {
  const { pathname } = useLocation();
  const hiddenRoutes = ["/shop", "/checkout", "/login", "/product/"];

  return (
    <>
      <Header
        videoUrl={mp4}
        logoAlt="Backhaus Häussler - bio & glutenfrei"
        fallbackImageUrl={fallBackImg}
        hiddenRoutes={hiddenRoutes.some(route => pathname.startsWith(route))}
      />
      <Navigation
        headerHeight={hiddenRoutes.some(route => pathname.startsWith(route)) ? 0 : 600}
        logoUrl={logo_black}
        logoOffcanvasUrl={logo}
        hiddenRoutes={hiddenRoutes.some(route => pathname.startsWith(route))}
      />
      <main style={{ marginTop: "165px", padding: "1rem" }}>
        {children}
      </main>
      <Footer
        logoUrl={logo_black}
        logoSmallUrl={logo_1024x1024}
        company={config.company}
        locality={config.locality}
        streetAddress={config.streetAddress}
        postalCode={config.postalCode}
        phone={config.phone}
        mail={config.mail}
      />
    </>
  );
};

export default Layout;